module.exports = "/_next/static/images/sb-b9736078651f3d8fa56e3c12d75796f9.svg";